import ApiServiceV2 from "../services/ApiServiceV2";

export type BasketData = {
    individualization_id: number
    kArtikel: string,
    quantity: number,
    images: {template_id: number, base64: string, svg: string}[]
    user_inputs: {spot_id: number, fabric: string|null}[]
    size: number
}

export const useCartAdd = () => {
    const api = new ApiServiceV2()

    const cart = async (element: BasketData) => {
        return await api.callApi('cart', 'post', element)
    }

    return {
        cart,
    }
}
